<template>
  <div>
    {{ toDo.summary
    }}<button
      type="button"
      class="-my-3 -ml-1 -mr-3 p-3 link"
      aria-label="Edit to-do"
      @click="handleEditClick"
    >
      <i class="fas fa-edit"></i>
    </button>
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

export default {
  props: {
    toDo: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleEditClick() {
      EventBus.$emit("edit-to-do", this.toDo.id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
